import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  toggleFormContainer: {
    position: 'relative',
  },
  toggleCloseButton: {
    position: 'absolute',
    color: theme.palette.neutralDark,
    right: pxToRem(15),
    top: pxToRem(10),
    selectors: {
      ':hover': {
        color: theme.palette.themeDarker,
      },
    },
  },
  productAddButton: {
    marginTop: pxToRem(20),
    textDecoration: 'none',
    fontFamily: 'SegoeUI',
    fontSize: pxToRem(14),
    selectors: {
      ':hover': {
        textDecoration: 'underline',
      },
    },
  },
  selectButtonDefault: {
    marginLeft: pxToRem(480),
  },
  selectButtonSelected: {
    marginLeft: pxToRem(480),
  },
  root: {
    backgroundColor: theme.palette.white,
    position: 'relative',
    padding: pxToRem(14),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  saveProductIdButton: {
    position: 'absolute',
    right: pxToRem(1),
    top: pxToRem(40),
  },
  productData: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: theme.palette.neutralPrimary,
  },
  desktopRemoveButton: {
    display: 'inline-block',
    height: 'auto',
    top: pxToRem(6),
  },
  editButton: {
    display: 'inline-block',
    marginLeft: pxToRem(48),
    height: 'auto',
    top: pxToRem(6),
  },
  productList: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: pxToRem(3),
    paddingBottom: pxToRem(3),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    fontSize: pxToRem(14),
    fontWeight: 400,
    font: 'SegoeUI',
  },
  bundledProducts: {
    selectors: {
      '& .ms-DetailsRow-cell[data-automation-key="productId"]': {
        padding: 0,
      },
    },
    paddingBottom: pxToRem(16),
    overflow: 'hidden',
  },
  dateContent: {
    paddingLeft: '0rem',
    paddingRight: '0rem',
  },
  moduleHeader: {
    paddingLeft: '0rem',
    paddingRight: '0rem',
    selectors: {
      '.ms-Button--default': {
        padding: `${pxToRem(7)} ${pxToRem(16)}`,
        maxWidth: 'none',
      },
    },
  },
  moduleContent: {
    paddingLeft: '0rem',
    paddingRight: '0rem',
    borderBottom: 'none',
  },
  datePicker: {
    width: '100%',
  },
  focusableGrid: {
    selectors: {
      ':focus': {
        outline: `thin solid ${theme.palette.black}`,
      },
    },
  },
});
